import {SET_EMOJI_CONTAINER_IS_DISPLAYED} from '../types';

function actionSetEmojiContainerIsDisplayed(isDisplayed)
{
    return {
        type: SET_EMOJI_CONTAINER_IS_DISPLAYED,
        payload: isDisplayed
    };
}

export default actionSetEmojiContainerIsDisplayed;


// WEBPACK FOOTER //
// ./redux/actions/emoji/actionSetEmojiContainerIsDisplayed.js